export const extractOrgFromContentId = (contentId: string): string => contentId.split('+')[0].split(':')[1];
export const languageExportId = 'languages-v1';
